(() => {
  if (!customElements.get('cart-drawer')) {
    class CartDrawer extends HTMLElement {
      constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        const overlay = this.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', this.close.bind(this));
        this.setHeaderCartIconAccessibility();
      }

      setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector('#cart-icon-bubble');
        if (!cartLink || cartLink.dataset.cartDrawerReady === 'true') return;

        cartLink.dataset.cartDrawerReady = 'true';
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(cartLink);
        });
        cartLink.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(cartLink);
          }
        });
      }

      open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

        window.clearTimeout(this.openTimer);
        this.openTimer = window.setTimeout(() => {
          this.classList.add('animate', 'active');
        });

        if (!this.transitionFocusPending) {
          this.transitionFocusPending = true;
          this.addEventListener(
            'transitionend',
            () => {
              this.transitionFocusPending = false;
              const containerToTrapFocusOn = this.classList.contains('is-empty')
                ? this.querySelector('.drawer__inner-empty')
                : document.getElementById('CartDrawer');
              const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
              if (containerToTrapFocusOn && focusElement && this.classList.contains('active')) {
                trapFocus(containerToTrapFocusOn, focusElement);
              }
            },
            { once: true }
          );
        }

        document.body.classList.add('overflow-hidden');
      }

      close() {
        window.clearTimeout(this.openTimer);
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
      }

      setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute('role', 'button');
        cartDrawerNote.setAttribute('aria-expanded', 'false');

        if (cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
          cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
        }

        cartDrawerNote.addEventListener('click', (event) => {
          event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        });

        if (cartDrawerNote.parentElement) cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
      }

      renderContents(parsedState) {
        this.classList.remove('is-empty');

        const drawerItems = this.querySelector('cart-drawer-items');
        if (drawerItems) drawerItems.classList.remove('is-empty');

        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          const sectionHtml = parsedState.sections && parsedState.sections[section.id];

          if (!sectionElement || !sectionHtml) return;
          const innerHtml = this.getSectionInnerHTML(sectionHtml, section.selector);
          if (innerHtml !== null) sectionElement.innerHTML = innerHtml;
        });

        const overlay = this.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', this.close.bind(this));

        // ORNEIGE: l'ajout au panier met à jour le contenu sans ouvrir automatiquement le drawer.
        // Le panier reste accessible normalement via l'icône du header.
      }

      getSectionInnerHTML(html, selector = '.shopify-section') {
        const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        return element ? element.innerHTML : null;
      }

      getSectionsToRender() {
        return [
          { id: 'cart-drawer', selector: '#CartDrawer' },
          { id: 'cart-icon-bubble' },
        ];
      }

      getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      }

      setActiveElement(element) {
        this.activeElement = element;
      }
    }

    customElements.define('cart-drawer', CartDrawer);
  }

  if (!customElements.get('cart-drawer-items')) {
    class CartDrawerItems extends CartItems {
      getSectionsToRender() {
        return [
          { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
        ];
      }
    }

    customElements.define('cart-drawer-items', CartDrawerItems);
  }
})();
